import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import {
  Button,
  Card,
  CardContent,
  FormControl,
  Select,
  Grid,
  InputLabel,
  TextField,
  FormHelperText,
  MenuItem,
  Input,
} from "@material-ui/core";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { getMaestras } from "../../actions/maestras-actions";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import deLocale from "date-fns/locale/es";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { getAllRoles } from "../../actions/role-actions";
import { styles } from "../styles";
import { defaultValues } from "./userModels";
import { updateUserInternal, getUserById } from "../../actions/user-actions";
import { ColorButton } from "../../utils/form/buttonsForm";
import { titleCase } from "title-case";
import { TextMaskCustom } from "../curriculumVitae/help";
import moment from "moment";
import _ from "lodash";
import Utils from "../../utils/utils";
import { REQUIRED_MESSAGE } from "../../constants";

const UserUpdateModalForm = (props) => {
  const classes = styles();
  const defaultValue = {
    roleList: [],
    status: "",
    secondName: "",
    secondSurname: "",
    password: "",
    gender: "",
    cargoId: "",
    phone: "",
  };

  const [maxDate, setMaxDate] = useState(
    Utils.getFormattedDateMMddyyyy(new Date(), ".")
  );
  const [resetForm, setResetForm] = useState(defaultValue);
  const [allRoles, setAllRoles] = useState([]);
  const [typeDocument, setTypeDocument] = useState(false);
  const [onSubmitDisabled, setSubmitDisabled] = useState(false);
  const [deleteField, setDeleteField] = useState(false);
  const [valuesUser, setValuesUser] = useState({
    document: "",
    type: "",
    phone: "",
  });
  const [maestras, setMaestras] = useState({
    generos: [],
    tipoDocumnetoIdentificacion: [],
  });
  const [userType, setUserType] = useState("");
  const [showTelephoneMessage, setShowTelephoneMessage] = useState(false);
  const [activeError, setActiveError] = useState(false);
  const [showCellPhoneMessage, setShowCellPhoneMessage] = useState(false);
  const [telephoneMessage, setTelephoneMessage] = useState(
    "Favor digitar indicativo de la zona"
  );

  const [valPhone, setValPhone] = useState(false);

  const [user, setUser] = useState({});

  useEffect(() => {
    const getListaMaestras = async () => {
      const response = await getMaestras();
      setMaestras(response?.data?.maestras);
    };
    getListaMaestras();
  }, []);

  const validateDate = () => {
    const currentyear=moment().year ()-1;
    return moment(currentyear+"-12-31").toDate();
  }

  const schema = yup.object().shape({
    documentType: yup
      .string()
      .nullable()
      .required(REQUIRED_MESSAGE),
    document: typeDocument
    ? yup
      .string()
      .required(REQUIRED_MESSAGE)
      .min(3, "Ingrese mínimo 3 dígitos")
      .max(16, "Ingrese máximo 16 dígitos")
      .matches(
        /^([0-9A-Za-zÑñ]{0,16})$/,
        "Ingrese un número de identificación válido"
      )
    : yup
      .string()
      .required(REQUIRED_MESSAGE)
      .min(3, "Ingrese mínimo 3 dígitos")
      .max(16, "Ingrese máximo 16 dígitos")
      .matches(
        /^([0-9]{0,16})$/,
        "Ingrese un número de identificación válido"
      ),
    firstName: yup
      .string()
      .nullable()
      .required(REQUIRED_MESSAGE)
      .min(3, "Ingrese mínimo 3 caracteres")
      .max(80, "Ingrese máximo 80 caracteres")
      .matches(
        /^(?=.{0,90}$)((\s?)([A-ZÀ-ÿa-z](|\(|\))?))+$/,
        "Ingrese un nombre válido"
      ),
    secondName:  resetForm.secondName === '' ? null : yup
      .string()
      .nullable()
      .min(3, "Ingrese mínimo 3 caracteres")
      .max(80, "Ingrese máximo 80 caracteres")
      .matches(
        /^(?=.{0,90}$)((\s?)([A-ZÀ-ÿa-z](|\(|\))?))+$/,
        "Ingrese un nombre válido"
      ),
    surname: yup
      .string()
      .nullable()
      .required(REQUIRED_MESSAGE)
      .min(3, "Ingrese mínimo 3 caracteres")
      .max(80, "Ingrese máximo 80 caracteres")
      .matches(
      /^(?=.{0,90}$)((\s?)([A-ZÀ-ÿa-z](|\(|\))?))+$/,
      "Ingrese un apellido válido"
      ),
    secondSurname:  resetForm.secondSurname === '' ? null : yup
      .string()
      .nullable()
      .notRequired()
      .min(3, "Ingrese mínimo 3 caracteres")
      .max(80, "Ingrese máximo 80 caracteres")
      .matches(
      /^(?=.{0,90}$)((\s?)([A-ZÀ-ÿa-z](|\(|\))?))+$/,
      "Ingrese un apellido válido"
      ),
    phone: valPhone ? null : yup
      .string()
      .transform(function(value) {
        let valor =  value
        ?.replace(/\(/g, "")
        ?.replace(/\)/g, "")
        ?.replace(/\-/g, "")
        ?.replace(/\s+/g, "");
        if(valor === "")return null;
        return valor;
      }
      )
      .notRequired()
      .nullable(true)
      .min(10, "Ingrese indicativo y mínimo 7 dígitos"),
    cellPhoneNumber: yup
      .string()
      .nullable()
      .transform((value) =>
        value
        .replace(/\(/g, "")
        .replace(/\)/g, "")
        .replace(/\-/g, "")
        .replace(/\s+/g, "")
        //.trim()
      )
      .required(REQUIRED_MESSAGE)
      .min(10, "Ingrese mínimo 10 dígitos"),
      //.max(10, "Ingrese máximo 10 dígitos"),
    password: resetForm.password === '' ? null : yup
      .string()
      .matches(
        resetForm.password === '' ? null :  /^(?!.*[\s])(?=.*?[A-Z])(?=.*?[0-9])(?=.*?\W)(?=.{8,}$).*$/,
        `Debe contener mínimo 8 caracteres. Al menos una letra en minúscula.
        Al menos una letra en mayúscula. Al menos un número.
        Al menos un caracter especial (Ejemplo: !, $, #, % )`
      ),
    validatePassword: yup
      .string()
      .nullable()
      .notRequired()
      .test(
        "match",
        "Las contraseñas no coinciden",
        function (validatePassword) {
          return validatePassword === this.parent.password;
        }
      ),
      dateBirth: yup
      .date()
      .nullable()
      .required(REQUIRED_MESSAGE)
      .min(new Date(1899, 11, 31, 23, 59, 29),

        `No puede ser menor a la fecha de 1900`
      )
      .max(validateDate(), "La fecha debe ser menor al año actual")
      .typeError("Ingrese un formato de fecha válido"),
    gender:  resetForm.gender
      ? null
      : yup.string()
        .nullable()
        .required(REQUIRED_MESSAGE),
    cargoId: !deleteField
      ? yup.string()
        .nullable()
        .required(REQUIRED_MESSAGE)
      : null,
    roleList: resetForm?.roleList?.length <= 0
      ? yup.string()
        .nullable()
        .required(REQUIRED_MESSAGE)
      :  null,
    status: resetForm?.status
      ? null
      : yup.string()
        .nullable()
        .required(REQUIRED_MESSAGE),
  });

  const { register, handleSubmit, setValue, control, errors, watch, getValues} = useForm({
    resolver: yupResolver(schema),
    defaultValues,
    mode: "all",
    reValidateMode: "onChange",
  });

  const valueTypeDocument = (watch("documentType") === "PP");
  const phone = (watch("phone") === '') ;

  useEffect(() => {
    if (valueTypeDocument) {
      setTypeDocument(true);
    } else {
      setTypeDocument(false);
    }

    if(phone){
      setValPhone(true);
    }else{
      setValPhone(false);
    }

  }, [valueTypeDocument, typeDocument,phone  ]);

  const callGetAllRoles = async () => {
    const response = await getAllRoles();
      setAllRoles(_.sortBy(response?.data?.roleList.filter(x => x.status !== "Inactivo" )));

  };

  const userUpdate = async () => {
    const response = await getUserById(props?.userId);
    const userEdit = response?.data;
    if (userEdit?.type === "EXTERNO") {
      setDeleteField(true);
    }
    setUserType(userEdit.type)
    setValue("document", userEdit?.person?.documentNumber)
    setValue("documentType", userEdit?.person?.documentType)
    setValue("firstName", userEdit?.person?.firstName);
    setValue("secondName", userEdit?.person?.secondName);
    setValue("surname", userEdit?.person?.surname);
    setValue("dateBirth", moment(userEdit?.person?.dateBirth).format());
    setValue("secondSurname", userEdit?.person?.secondSurname);
    setValue("phone", userEdit?.person?.phone);
    setValue("externalEmail", userEdit?.person?.externalEmail);
    setValue("internalEmail", userEdit?.person?.internalEmail);
    setValue("password", userEdit?.person?.password);
    setValue("cellPhoneNumber", userEdit?.person?.cellPhoneNumber);
    setValue("gender", userEdit?.person?.domainGender);
    setValue("cargoId", userEdit?.person?.charge?.id);
    setValue("status", userEdit?.status);
    setUser(response?.data);
    setResetForm({
      ...resetForm,
      roleList: userEdit?.roleList,
      status: userEdit?.status,
      gender: userEdit?.person?.domainGender,
      cargoId: userEdit?.person?.charge?.id,
      phone: userEdit?.person?.phone,
    });
  };

  useEffect(() => {
    callGetAllRoles();
    userUpdate();
  }, []);

  const onChangeValues = (e) => {
    const { name, value } = e.target;
    setResetForm({ ...resetForm, [name]: value });
  };

  const handleClickCloseAndReset = () => {
    props.setOpenEdit(false);
    props.refresh();
    props.handleClickReset();
    setSubmitDisabled(false);
  };

  const handleClickCloseModal = () => {
    props.setMessage({ ...props.message, open: false });
    setSubmitDisabled(false);
  };

  const stateFieldEdit = () =>{
    props.setOpenEdit(false);
    props.setMessage({ ...props.message, open: false });
  };

  const cancelConfirmEdit = () => {
    props.setMessage({
      description: "¿Está seguro que NO desea continuar editando el usuario?",
      textButtonSubmit: "Aceptar",
      handleClick: () => stateFieldEdit(),
      handleClickOut: () => handleClickCloseModal(),
      type: "WARNING",
      open: true,
    });
  };

  const onSubmit = (data) => {
    const infoExternalUser = {
      id: user?.id,
      firstName: data.firstName,
      secondName: data?.secondName ? data?.secondName : null,
      surname: data.surname,
      dateBirth: moment(data.dateBirth).format("YYYY-MM-DDTHH:mm"),
      secondSurname: data?.secondSurname ? data?.secondSurname : null,
      cellPhoneNumber: data?.cellPhoneNumber,
      documentNumber: data?.document,
      documentType: data?.documentType,
      externalEmail: user?.person?.externalEmail,
      internalEmail: user?.person?.internalEmail,
      type: user?.type,
      phone: data?.phone
      ?.replace(/\(/g, "")
      ?.replace(/\)/g, "")
      ?.replace(/\-/g, "")
      ?.replace(/\s+/g, ""),
        //.trim(),
      gender: resetForm.gender,
      status: resetForm.status,
      password: data.validatePassword ? data?.validatePassword : null,
      cargoId: !deleteField ? data.cargoId : "",
      personId: user?.person?.id,
      roleList: !deleteField
        ? resetForm?.roleList?.map(function (item) {
            return item["id"];
          })
        : [],
    };
    props.setMessage({
      description: "¿Está seguro que desea actualizar el registro?",
      textButtonSubmit: "Aceptar",
      handleClick: () => userInternal(infoExternalUser),
      handleClickOut: () => handleClickCloseModal(),
      type: "WARNING",
      open: true,
    });
  };

  const userInternal = async (data) => {
    props.setMessage({ ...props.message, open: false });
    const response = await updateUserInternal(data);
    if (response && (response?.status === 200 || response?.status === 201)) {
      props.setMessage({
        description: `Usuario actualizado exitosamente`,
        textButtonSubmit: "ACEPTAR",
        handleClick: () => handleClickCloseAndReset(),
        oneButtons: true,
        type: "SUCCESS",
        open: true,
      });
    } else if (response?.status > 399 && response?.status !== 401 && response?.status !==403) {
      props.setMessage({
        //description : `Ocurrió un error procesando la solicitud, inténtelo nuevamente`,
        description: response?.data?.detail
          ? response?.data?.detail
          : response?.data?.error,
        textButtonSubmit: "ACEPTAR",
        handleClick: () => handleClickCloseModal(),
        oneButtons: true,
        type: "WARNING",
        open: true,
      });
    } else {
      props.setMessage({
        description: `Ocurrió un error procesando la solicitud, inténtelo nuevamente`,
        textButtonSubmit: "ACEPTAR",
        handleClick: () => handleClickCloseModal(),
        oneButtons: true,
        type: "WARNING",
        open: true,
      });
    }
  };

  const handleUserKeyPress = (e) => {
    const { value, name } = e.target;
    let invalidChars = ["-", "e", "+", "E", ".", ","];
    if (invalidChars?.includes(e.key)) {
      e.preventDefault();
    }
    if (value) setActiveError(true);

  };

  const onTelephoneChange = (e) => {
    e.preventDefault();
    const { value, name } = e.target;
    setValuesUser({...valuesUser, [name]: value})
    if (
      name === "cellPhoneNumber" &&
      parseInt(value) > 999999 &&
      parseInt(value) < 999999999
    ) {
      setShowCellPhoneMessage(true);
    } else {
      setShowCellPhoneMessage(false);
    }
    if (name === 'phone' && parseInt(value) > 999999 && parseInt(value) < 999999999) {
      setShowTelephoneMessage(false);
    } else {
      setShowTelephoneMessage(false);
    }
  };

  const filterWithoutRCV = maestras?.tipoDocumnetoIdentificacion.filter(
    (x) => x.key !== "RC"
  );

  const handleOnchage = (e) => {
    setValue("document", "");
  };

  const handleUserKeyPressDocumento = (e) => {
    var form = getValues();
    if (form.documentType !== "PP") {
      let validChars = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"];
      if (!validChars.includes(e.key)) {
        e.preventDefault();
      }
    }
  };

  return (
    <Card elevation={0} style={{ background: "rgb(238 251 255)" }}>
      <CardContent>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid
            container
            spacing={3}
            alignItems="center"
            style={{
              background: "rgb(238 251 255)",
              borderRadius: 15,
              display: "flex",
            }}
          >
            <Grid item xs={12} md={3} lg={3}>
              <FormControl fullWidth>
                <TextField
                  fullWidth
                  type="text"
                  variant="outlined"
                  inputRef={register}
                  className={classes.dropdown}
                  label="Primer Nombre *"
                  name="firstName"
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  error={
                    !!errors.hasOwnProperty("firstName") &&
                    errors["firstName"].message
                  }
                  helperText={
                    errors.hasOwnProperty("firstName") &&
                    errors["firstName"].message
                  }
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} md={3} lg={3}>
              <FormControl fullWidth>
                <TextField
                  fullWidth
                  type="text"
                  variant="outlined"
                  inputRef={register}
                  onChange={onChangeValues}
                  className={classes.dropdown}
                  label="Segundo Nombre"
                  name="secondName"
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  error={
                    resetForm.secondName === ""
                      ? null
                      : !!errors.hasOwnProperty("secondName") &&
                        errors["secondName"].message
                  }
                  helperText={
                    resetForm.secondName === ""
                      ? null
                      : errors.hasOwnProperty("secondName") &&
                        errors["secondName"].message
                  }
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} md={3} lg={3}>
              <FormControl fullWidth>
                <TextField
                  fullWidth
                  variant="outlined"
                  inputProps={{ maxLength: 80 }}
                  inputRef={register}
                  className={classes.dropdown}
                  label="Primer Apellido *"
                  name="surname"
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  error={
                    !!errors.hasOwnProperty("surname") &&
                    errors["surname"].message
                  }
                  helperText={
                    errors.hasOwnProperty("surname") &&
                    errors["surname"].message
                  }
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} md={3} lg={3}>
              <FormControl fullWidth>
                <TextField
                  fullWidth
                  variant="outlined"
                  inputRef={register}
                  className={classes.dropdown}
                  label="Segundo Apellido"
                  onChange={onChangeValues}
                  name="secondSurname"
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  error={ resetForm.secondSurname === ''
                    ? null
                    : !!errors.hasOwnProperty("secondSurname") &&
                      errors["secondSurname"].message
                  }
                  helperText={ resetForm.secondSurname === ''
                    ? null
                    : errors.hasOwnProperty("secondSurname") &&
                      errors["secondSurname"].message
                  }
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} md={3} lg={3}>
              <FormControl
                variant="outlined"
                fullWidth
                size="small"
                error={
                    !!errors.hasOwnProperty("documentType") &&
                      errors["documentType"].message
                }
              >
                <InputLabel htmlFor="outlined-select-documentType" shrink={true}>
                  Tipo de documento *
                </InputLabel>
                <Controller
                  fullWidth
                  control={control}
                  inputRef={register}
                  className={classes.dropdown}
                  label="TIPO DE DOCUMENTO *"
                  name="documentType"
                  size="small"
                  notched={true}
                  onChange={(e) => handleOnchage(e.target.value)}
                  defaultValue=""
                  inputProps={{
                    name: "documentType",
                    id: "outlined-select-documentType",
                  }}
                  error={errors.hasOwnProperty("documentType") && errors["documentType"].message}
                  as={
                    <Select >
                    {filterWithoutRCV.map((type) => (
                      <MenuItem
                        className={classes.menuItem}
                        key={type.value}
                        value={type.key}
                      >
                        {type.value}
                      </MenuItem>
                          ))}
                        </Select>
                      }
                    />
                    <FormHelperText>
                      {errors.hasOwnProperty("documentType") && errors["documentType"].message}
                    </FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={3} lg={3}>
              <FormControl fullWidth>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  inputRef={register}
                  type="text"
                  name="document"
                  defaultValue=""
                  className={classes.dropdown}
                  placeholder="Número de documento"
                  variant="outlined"
                  fullWidth
                  size="small"
                  label="Número de Documento *"
                  error={
                    errors.hasOwnProperty("document") &&
                    errors["document"].message
                  }
                  onKeyPress={handleUserKeyPressDocumento }
                />
              </FormControl>
              <FormHelperText style={{ color: "#f44336" }}>
                {errors.hasOwnProperty("document") &&
                  errors["document"].message}
              </FormHelperText>
            </Grid>

            <Grid item xs={12} md={3} lg={3}>
              <FormControl fullWidth>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  inputRef={register}
                  type="email"
                  name="externalEmail"
                  defaultValue=""
                  className={classes.disabled}
                  variant="outlined"
                  fullWidth
                  size="small"
                  label="Correo Personal"
                  disabled={true}
                  error={
                    errors.hasOwnProperty("externalEmail") &&
                    errors["externalEmail"].message
                  }
                  onKeyPress={handleUserKeyPress}
                />
              </FormControl>
              <FormHelperText style={{ color: "#f44336" }}>
                {errors.hasOwnProperty("externalEmail") &&
                  errors["externalEmail"].message}
              </FormHelperText>
            </Grid>
            <Grid item xs={12} md={3} lg={3}>
              <FormControl fullWidth>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  inputRef={register}
                  type="email"
                  name="internalEmail"
                  defaultValue=""
                  className={classes.disabled}
                  variant="outlined"
                  fullWidth
                  size="small"
                  label="Correo Corporativo"
                  disabled={true}
                  error={
                    errors.hasOwnProperty("internalEmail") &&
                    errors["internalEmail"].message
                  }
                  onKeyPress={handleUserKeyPress}
                />
              </FormControl>
              <FormHelperText style={{ color: "#f44336" }}>
                {errors.hasOwnProperty("internalEmail") &&
                  errors["internalEmail"].message}
              </FormHelperText>
            </Grid>

            <Grid item xs={12} md={3} lg={3}>
              <FormControl
                variant="outlined"
                fullWidth
                size="small"
                error={
                  !!errors.hasOwnProperty("gender") && errors["gender"].message
                }
              >
                <InputLabel htmlFor="outlined-select-gender" shrink={true}>
                  Género
                </InputLabel>
                <Select
                  fullWidth
                  inputRef={register}
                  className={classes.dropdown}
                  label="Género"
                  onChange={onChangeValues}
                  value={resetForm?.gender}
                  name="gender"
                  size="small"
                  notched={true}
                  inputProps={{
                    name: "gender",
                    id: "outlined-select-gender",
                  }}
                >
                  {maestras?.generos?.map((gender) => (
                    <MenuItem
                      className={classes.menuItem}
                      key={gender?.index}
                      value={gender?.key}
                    >
                      {gender?.value}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>
                  {errors.hasOwnProperty("gender") && errors["gender"].message}
                </FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={3} lg={3}>
              <FormControl fullWidth>
                <MuiPickersUtilsProvider
                  locale={deLocale}
                  utils={DateFnsUtils}
                >
                <Controller
                  as={
                    <KeyboardDatePicker
                      fullWidth
                      inputVariant="outlined"
                      variant="inline"
                      name="dateBirth"
                      className = {classes.dropdown}
                      format="dd/MM/yyyy"
                      label="Fecha de nacimiento "
                      InputLabelProps={{ shrink: true }}
                      error={
                        !!errors.hasOwnProperty("dateBirth") &&
                        errors["dateBirth"].message
                      }
                      helperText={
                        errors.hasOwnProperty("dateBirth") &&
                        errors["dateBirth"].message
                      }
                      minDate={"01.01.1900"}
                      minDateMessage={"No puede ser menor a 1900"}
                      maxDate={maxDate}
                    />
                  }
                  control={control}
                  name="dateBirth"
                  placeholder="dd/mm/yyyy"
                  size="small"
                />
                </MuiPickersUtilsProvider>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={3} lg={3}>
            <FormControl
              fullWidth
              style={{ marginTop: "0px" }}
              error={
                !!errors.hasOwnProperty("cellPhoneNumber") && errors["cellPhoneNumber"].message
              }
            >
              <InputLabel
                htmlFor="cellPhoneNumber"
                style={{ zIndex: 2, marginTop: "-7px", paddingLeft: "10px" }}
              >
                No. Celular *
              </InputLabel>
              <Input
                id="cellPhoneNumber"
                inputComponent={TextMaskCustom}
                variant="outlined"
                type="text"
                notched={true}
                inputRef={register}
                className={classes.formField}
                style={{ marginTop: "0px" }}
                inputProps={{
                  style: {
                    height: "18px",
                    borderRadius: "8px",
                    paddingBottom: "0px",
                    fontSize: 14,
                    paddingLeft: "12px",
                  },
                }}
                onKeyPress={handleUserKeyPress}
                onChange={onTelephoneChange}
                name="cellPhoneNumber"
                size="small"
              />
              <FormHelperText style={{ color: "#f44336" }}>
                {errors.hasOwnProperty("cellPhoneNumber") && errors["cellPhoneNumber"].message}
              </FormHelperText>
              <FormHelperText style={{ color: "#f44336" }}>
                {showCellPhoneMessage && telephoneMessage}
              </FormHelperText>
            </FormControl>

            </Grid>

            <Grid item xs={12} md={3} lg={3}>
            <FormControl
              fullWidth
              style={{ marginTop: "0px" }}
              error={errors.hasOwnProperty("phone") && errors["phone"].message}
            >
              <InputLabel
                htmlFor="phone"
                style={{ zIndex: 2, marginTop: "-7px", paddingLeft: "10px" }}
              >
                No. Teléfono
              </InputLabel>
              <Input
                id="phone"
                inputComponent={TextMaskCustom}
                variant="outlined"
                type="text"
                notched={true}
                inputRef={register}
                className={classes.formField}
                name="phone"
                style={{ marginTop: "0px" }}
                inputProps={{
                  style: {
                    height: "18px",
                    borderRadius: "8px",
                    paddingBottom: "0px",
                    fontSize: 14,
                    paddingLeft: "12px",
                  },
                }}
                onKeyPress={handleUserKeyPress}
                onChange={onTelephoneChange}
                size="small"
              />
              <FormHelperText style={{ color: "#f44336" }}>
                { errors.hasOwnProperty("phone") && errors["phone"].message}
              </FormHelperText>
              <FormHelperText style={{ color: "#f44336" }}>
                {!errors.hasOwnProperty("phone") &&  showTelephoneMessage && telephoneMessage}
              </FormHelperText>
            </FormControl>
            </Grid>
            <Grid item xs={12} md={3} lg={3}>
              <FormControl fullWidth>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  inputRef={register}
                  type="password"
                  name="password"
                  defaultValue=""
                  className={classes.disabled}
                  placeholder="***********"
                  variant="outlined"
                  fullWidth
                  size="small"
                  label="Contraseña"
                  disabled={true}
                  error={
                    errors.hasOwnProperty("password") &&
                    errors["password"].message
                  }
                  onKeyPress={handleUserKeyPress}
                />
              </FormControl>
              <FormHelperText style={{ color: "#f44336" }}>
                {errors.hasOwnProperty("password") &&
                  errors["password"].message}
              </FormHelperText>
            </Grid>

            {userType === "INTERNO" ? <Grid item xs={12} md={3} lg={3}>
              <FormControl
                fullWidth
                error={
                  resetForm?.roleList?.length <= 0 ? errors.hasOwnProperty('roleList') &&
                    errors['roleList'].message : ''
                }
              >
                <Autocomplete
                  multiple
                  name="roleList"
                  value={resetForm?.roleList}
                  options={allRoles }
                  className = {classes.dropdownMultiple}
                  onChange={(e, newval, reason) => {
                    setResetForm({...resetForm, roleList:newval});
                  }}
                  getOptionLabel={(option) => titleCase(option?.name)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      inputRef={register}
                      name="roleList"
                      label="Rol *"
                      InputLabelProps={{ shrink: true }}
                      placeholder="Rol ABC"
                      error={resetForm?.roleList?.length <= 0 ? errors.hasOwnProperty('roleList') && errors['roleList'].message : ''}
                    />
                  )}
              />
                  <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                    {resetForm?.roleList?.length <= 0 ? errors.hasOwnProperty('roleList') &&
                    errors['roleList'].message : ''}
                  </FormHelperText>
              </FormControl>
            </Grid> : null }
            {userType === "INTERNO" ? <Grid item xs={12} md={3} lg={3}>
              <FormControl
                variant="outlined"
                fullWidth
                size="small"
                error={
                  !!errors.hasOwnProperty("cargoId") &&
                  errors["cargoId"].message
                }
              >
                <InputLabel
                  htmlFor="outlined-select-cargoId"
                  shrink={true}
                >
                  Cargo *
                </InputLabel>
                <Controller
                  control = {control}
                  name='cargoId'
                  inputRef={register}
                  fullWidth
                  defaultValue=''
                  //className = {classes.dropdown}
                  className={classes.disabled}
                  label="Cargo"
                  size="small"
                  notched={true}
                  disabled={true}
                  inputProps={{
                    name: "cargoId",
                    id: "outlined-select-cargoId",
                  }}
                  as={
                    <Select>
                      {props?.charges?.map((c) => (
                          <MenuItem
                            className={classes.menuItem}
                            id ={c.id}
                            key={c.id}
                            value={c.id}
                          >
                            {c.denomination}
                          </MenuItem>
                        )
                      )}
                    </Select>
                  }
                />
                <FormHelperText>
                  {errors.hasOwnProperty("cargoId") &&
                    errors["cargoId"].message}
                </FormHelperText>
                </FormControl>
              </Grid> : null}
            {userType === "INTERNO" ? (
              <Grid item xs={12} md={3} lg={3}>
                <FormControl
                  variant="outlined"
                  fullWidth
                  error={
                    !!errors.hasOwnProperty("status") &&
                    errors["status"].message
                  }
                >
                  <InputLabel htmlFor="outlined-select-status" shrink={true}>
                    Estado
                  </InputLabel>
                  <Select
                    fullWidth
                    className={classes.dropdown}
                    inputRef={register}
                    label="Estado"
                    notched={true}
                    onChange={onChangeValues}
                    value={resetForm?.status}
                    name="status"
                    inputProps={{
                      name: "status",
                      id: "outlined-select-estado",
                    }}
                  >
                    <MenuItem
                      className={classes.menuItem}
                      key="ACTIVO"
                      value="ACTIVO"
                    >
                      Activo
                    </MenuItem>
                    <MenuItem
                      className={classes.menuItem}
                      key="INACTIVO"
                      value="INACTIVO"
                    >
                      Inactivo
                    </MenuItem>
                  </Select>
                  <FormHelperText>
                    {errors.hasOwnProperty("status") &&
                      errors["status"].message}
                  </FormHelperText>
                </FormControl>
              </Grid>
            ) : null}
            <Grid item xs={12} md={3} lg={3}>
              <Button
                style={{
                  backgroundColor: "transparent",
                  color: "#7EBDCE",
                  width: "100px",
                  marginRight: "20px",
                }}
                variant="outlined"
                onClick={cancelConfirmEdit}
              >
                CANCELAR
              </Button>
              <ColorButton
                style={{ width: "100px" }}
                type="submit"
                disabled={onSubmitDisabled}
              >
                GUARDAR
              </ColorButton>
            </Grid>
          </Grid>
        </form>
      </CardContent>
    </Card>
  );
};

export default UserUpdateModalForm;
